import { CourseUserTypeEnum } from "@core/enums/courseUserType";
import type {
  UserInfoDtoWithToken,
  UserInfoWithProfileImageDto,
  UserShortDto,
} from "@core/types";
import type { UserDto } from "@core/typesV2";
import { bindAll } from "@core/utils";
import { NavigateFunction } from "react-router-dom";

import AxiosService, { TokenHandlers } from "./axiosService";
import MockAuthService from "./mockAuthService";

export type UserEmailsRequest = {
  emails: string[];
};

export type UsersExistenceByEmailsReply = {
  users: UserDto[];
  notFoundEmails: string[];
};

export default class UserService extends AxiosService {
  constructor(tokenHandlers: TokenHandlers, navigateTo: NavigateFunction) {
    super("users", tokenHandlers, navigateTo);
    bindAll(this);
  }

  getUserInfo() {
    if (MockAuthService.isEnabled && MockAuthService.isAuthorized) {
      return this.mockLogin(
        MockAuthService.getLogin()!,
        MockAuthService.getPassword()!,
      );
    }

    return this.get<UserInfoDtoWithToken>("info");
  }

  mockLogin(
    userName: string,
    password: string,
    { skipNavigateIfError = false } = {},
  ) {
    return this.post<
      UserInfoDtoWithToken,
      { userName: string; password: string }
    >(
      "login-mock",
      {
        userName,
        password,
      },

      undefined,
      { skipNavigateIfError },
    );
  }

  getGraders(searchTerm: string, skip?: number, take?: number) {
    return this.get<Array<UserShortDto>, unknown>(`graders`, {
      params: {
        searchTerm: searchTerm,
        skip: skip,
        take: take,
      },
    });
  }

  getUsers(
    courseUserType: CourseUserTypeEnum,
    searchTerm: string,
    skip?: number,
    take?: number,
  ) {
    return this.get<Array<UserInfoWithProfileImageDto>, unknown>("", {
      params: {
        courseUserType: courseUserType,
        searchTerm: searchTerm,
        skip: skip,
        take: take,
      },
    });
  }

  checkEmails(emails: string[]) {
    return this.post<UsersExistenceByEmailsReply, UserEmailsRequest>(
      "check-emails",
      { emails },
    );
  }
}
